module.exports = __webpack_public_path__ + "img/mrtxt.7c641b4c.png";